import * as React from "react";

interface Props {
  readonly children: JSX.Element;
}

interface State {
  readonly error?: Error;
  readonly hasError: boolean;
  readonly info?: React.ErrorInfo;
}

export default class ErrorBoundary extends React.PureComponent<Props, State> {
  public readonly state: State = {
    error: undefined,
    hasError: false,
    info: undefined,
  };

  public componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.setState({
      error,
      hasError: true,
      info,
    });
  }

  public render(): React.ReactNode {
    const { error, hasError, info } = this.state;
    if (hasError) {
      return (
        <div style={{ padding: 20 }}>
          <div className="component-exception centered">
            <strong>Unexpected error!</strong>
            <pre className="preserve-space">
              {error && error.toString()}
              <br />
              {info && info.componentStack}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
